// Google reCAPTCHA v3 Configuration
export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || '6LefgkwsAAAAAHyVM5hK7VeNsS_ZKcLz7VycT2iP';

export const executeRecaptcha = async (action) => {
  if (!window.grecaptcha) {
    console.error('reCAPTCHA not loaded');
    return null;
  }

  try {
    await window.grecaptcha.ready(() => {});
    const token = await window.grecaptcha.execute(RECAPTCHA_SITE_KEY, { action });
    return token;
  } catch (error) {
    console.error('reCAPTCHA execution failed:', error);
    return null;
  }
};
